import { ReactNode } from 'react';
import theme from './ReorderableList.module.scss';
import { arrayMove, Sortable, SortableProps } from '@ygtechnologies/bygr-frontend-component-library';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';

interface ReorderableListProps<T> {
    data: T[];
    idField: SortableProps<T>['idField'];
    renderer(item: T): ReactNode;
    onChange(newData: T[]): void;
}

function ReorderableList<T>({ data, idField, onChange, renderer }: ReorderableListProps<T>) {
    const onSortEnd = ({ oldIndex, newIndex }) => {
        const newArray = arrayMove(data, oldIndex, newIndex);
        triggerHandler(onChange, newArray);
    };

    return (
        <ul className={theme.list}>
            <Sortable items={data} idField={idField} onSortEnd={onSortEnd} direction="vertical">
                {(item, { handleProps }) => (
                    <li {...handleProps} className={theme.item}>
                        {renderer(item)}
                    </li>
                )}
            </Sortable>
        </ul>
    );
}

export default ReorderableList;
